export class WFEBudgetedGLAccountSelectorResultDto {
    glAccountNumber: string;
    glAccountDisplayText: string;
    isVendorDefaultAccount: boolean;
    isBudgeted: boolean;
    budgetAmount: number;
    subAccountId: number;
}
